import { FiGrid, FiUsers, FiShield, FiBookOpen, FiUsers as FiParties, FiFileText, FiRepeat, FiBarChart2, FiUser, FiMonitor, FiTool, FiClock, FiCalendar, FiDollarSign, FiTruck, FiBox, FiSettings, FiList, FiLayers } from 'react-icons/fi';

export const MENU = [
  {
    label: 'Dashboard',
    icon: FiGrid,
    to: '/',
    permission: 'view-dashboard',
  },
  {
    group: 'Administration',
  },
  {
    label: 'Users',
    icon: FiUsers,
    to: '/users',
    permission: 'view-users',
  },
  {
    label: 'Roles & Permissions',
    icon: FiShield,
    to: '/roles',
    permission: 'view-roles',
  },
  {
    label: 'Account Permissions',
    icon: FiShield,
    to: '/account-permissions',
    permission: 'manage-roles',
  },
  {
    group: 'Finance & Accounts',
  },
  {
    label: 'Chart of Accounts',
    icon: FiBookOpen,
    to: '/accounts/coa',
    permission: 'view-accounts',
  },
  {
    label: 'Account Structure',
    icon: FiLayers,
    to: '/accounts/structure',
    permission: 'create-accounts',
  },
  {
    label: 'Parties',
    icon: FiParties,
    to: '/parties',
    permission: 'view-parties',
  },
  {
    label: 'Suppliers',
    icon: FiTruck,
    to: '/suppliers',
    permission: 'view-suppliers',
  },
  {
    label: 'Vouchers',
    icon: FiRepeat,
    to: '/vouchers',
    permission: 'view-vouchers',
    children: [
      { label: 'All Vouchers', to: '/vouchers' },
      { label: 'New Voucher', to: '/vouchers/new' },
    ],
  },
  {
    label: 'Invoices',
    icon: FiFileText,
    to: '/invoices',
    permission: 'view-invoices',
    children: [
      { label: 'All Invoices', to: '/invoices' },
      { label: 'New Invoice', to: '/invoices/new' },
      { label: 'Payments', to: '/payments' },
    ],
  },
  {
    group: 'Reports',
  },
  {
    label: 'Reports',
    icon: FiBarChart2,
    to: '/reports',
    permission: 'view-reports',
  },
  {
    group: 'HR & Production',
  },
  {
    label: 'Employees',
    icon: FiUser,
    to: '/employees',
    permission: 'view-employees',
  },
  {
    label: 'Departments',
    icon: FiLayers,
    to: '/departments',
    permission: 'view-departments',
  },
  {
    label: 'Shifts',
    icon: FiLayers,
    to: '/shifts',
    permission: 'view-employees',
  },
  {
    label: 'Advances',
    icon: FiDollarSign,
    to: '/advances',
    permission: 'view-employees',
  },
  {
    label: 'Machines',
    icon: FiMonitor,
    to: '/machines',
    permission: 'view-machines',
  },
  {
    label: 'Stitches',
    icon: FiTool,
    to: '/stitches',
    permission: 'view-stitches',
  },
  {
    label: 'Machine Articles',
    icon: FiLayers,
    to: '/machine-articles',
    permission: 'view-machine-articles',
  },
  {
    label: 'Attendance',
    icon: FiClock,
    to: '/attendance',
    permission: 'view-attendance',
  },
  {
    label: 'Leaves',
    icon: FiCalendar,
    to: '/leaves',
    permission: 'view-leaves',
  },
  {
    label: 'Payroll',
    icon: FiDollarSign,
    to: '/payroll',
    permission: 'view-payroll',
  },
  {
    group: 'Inventory',
  },
  {
    label: 'Gatepass',
    icon: FiTruck,
    to: '/gatepasses',
    permission: 'view-gatepasses',
  },
  {
    label: 'Inventory Items',
    icon: FiBox,
    to: '/inventory/items',
    permission: 'view-inventory',
  },
  {
    label: 'Units',
    icon: FiBox,
    to: '/inventory/units',
    permission: 'view-units',
  },
  {
    label: 'Stock',
    icon: FiBox,
    to: '/inventory/stock',
    permission: 'view-inventory',
  },
  {
    group: 'System',
  },
  {
    label: 'Activity Logs',
    icon: FiList,
    to: '/activity-logs',
    permission: 'view-activity-logs',
  },
  {
    label: 'Settings',
    icon: FiSettings,
    to: '/settings',
    permission: 'view-settings',
  },
];

export default MENU;